module.exports = __webpack_public_path__ + "img/1439984674.72d95791.jpg";